module.exports = __webpack_public_path__ + "static/media/BigJohnPRO-Regular.809259dc.woff2";